import { useState, createContext, FC, useContext, useEffect, useMemo, useCallback } from 'react';

import { DimensionConfigType } from 'types/pricingSimulator';

import { pricingSimulatorUrls } from 'config/urls';

import { useFetchDimensionConfigData } from 'hooks/pricingSimulator/useFetchDimensionConfigData';

const pricingSimulatorWrapperDataContext = createContext<{
    dimensionConfigData: DimensionConfigType | null;
    setDimensionConfigData: Function;
    loading: boolean;
}>({
    dimensionConfigData: null,
    setDimensionConfigData: () => {},
    loading: true,
});
interface props {
    children: React.ReactNode;
}

const PricingSimulatorWrapperContext: FC<props> = ({ children }) => {
    //stores dimension related config keys
    const [dimensionConfigData, setDimensionConfigData] = useState<DimensionConfigType | null>(null);

    //GET DIMENSION CONFIG DATA FROM BACKEND
    const { loading } = useFetchDimensionConfigData({
        method: 'get',
        //  queryConfig: {},
        queryKey: ['ps-dimension-config'],
        url: `${pricingSimulatorUrls.getDimensionConfigDataUrl}`,
        variables: {},
        setDimensionConfigData,
    });

    return (
        <pricingSimulatorWrapperDataContext.Provider
            value={{
                dimensionConfigData,
                setDimensionConfigData,
                loading,
            }}
        >
            {children}
        </pricingSimulatorWrapperDataContext.Provider>
    );
};

export { pricingSimulatorWrapperDataContext, PricingSimulatorWrapperContext };
